import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@spotahome/ui-library';
import Tracking from '@spotahome/soyuz-tracking';
import { trans } from '@spotahome/soyuz/client';

import SortBy from '../SortBy';

import { generateTitleElems } from './utils';

import './SearchTitle.scss';

const SearchTitle = ({
  totalResults,
  orderBy,
  onSortChange,
  types,
  cityName,
  currentNeighborhood,
  onClearFilters,
  showClearFiltersButton,
  topology
}) => {
  const title = generateTitleElems(
    types,
    cityName,
    topology,
    currentNeighborhood
  );
  const handleClearFilters = () => {
    onClearFilters();
    Tracking.ga.sendEvent('Search', 'clear-all-filters');
  };

  return (
    <div className="search-title">
      <h1 className="search-title__title" data-test="search-title">
        <strong>{totalResults}</strong> {title}
      </h1>

      <div className="search-title__summary">
        {showClearFiltersButton ? (
          <Button
            color="select"
            alt
            size="small"
            onClick={handleClearFilters}
            className="search-title__clear"
            data-test="title-filters-summary-clear-button"
          >
            {trans('search.prefilters.summary.title')}
          </Button>
        ) : null}
        <SortBy
          handleSortByChange={onSortChange}
          orderBy={orderBy}
          borderless
        />
      </div>
    </div>
  );
};

SearchTitle.propTypes = {
  totalResults: PropTypes.number,
  orderBy: PropTypes.string,
  onSortChange: PropTypes.func,
  types: PropTypes.arrayOf(PropTypes.string).isRequired,
  cityName: PropTypes.string.isRequired,
  currentNeighborhood: PropTypes.string,
  onClearFilters: PropTypes.func,
  showClearFiltersButton: PropTypes.bool.isRequired,
  topology: PropTypes.arrayOf(PropTypes.string).isRequired
};

SearchTitle.defaultProps = {
  totalResults: 0,
  orderBy: undefined,
  onSortChange: () => {},
  currentNeighborhood: '',
  onClearFilters: () => {}
};

export default SearchTitle;
